import { render, staticRenderFns } from "./DeckCard.vue?vue&type=template&id=832335e4&scoped=true"
import script from "./DeckCard.vue?vue&type=script&lang=js"
export * from "./DeckCard.vue?vue&type=script&lang=js"
import style0 from "./DeckCard.vue?vue&type=style&index=0&id=832335e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832335e4",
  null
  
)

export default component.exports